var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "members" }, [
    _c(
      "div",
      { staticClass: "members__wrapper" },
      [
        _c("BaseTitle", {
          staticClass: "members__title",
          attrs: { text: _vm.titleText }
        }),
        _c("MembersList"),
        _c("BaseBtn", {
          attrs: {
            text: _vm.btnText,
            to: "participants-page",
            customClass: "default"
          },
          nativeOn: {
            click: function($event) {
              return _vm.getCategoryId($event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d303062", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d303062","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/MembersBlock.vue
// module id = e34K
// module chunks = 0